import { BellRing, FlaskConical } from "lucide-react";

export default function RestockTab(props) {
  const { compoundReqs, grouped, notifyRestock, restock } = props;
  return (
          <div className="space-y-6">
          <div className="border border-zinc-800" data-testid="restock-table">
            {grouped.length === 0 && <p className="p-8 text-center font-mono text-sm text-[#52525B]" data-testid="restock-empty">No restock requests yet.</p>}
            {grouped.map((g) => (
              <div key={g.product_id} className="px-6 py-5 border-b border-zinc-900 flex items-center justify-between gap-4 hover:bg-[#0C0C0C] transition-colors" data-testid={`restock-group-${g.product_id}`}>
                <div className="min-w-0">
                  <p className="font-serif text-xl font-light">{g.product_name}</p>
                  <p className="font-mono text-[11px] text-[#71717A] mt-1">{g.pending} waiting · {g.total} total requests</p>
                </div>
                <button onClick={() => notifyRestock(g.product_id, g.product_name)} disabled={g.pending === 0}
                  data-testid={`restock-notify-${g.product_id}`}
                  className="flex items-center gap-2 bg-[#D4AF37] text-black px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.15em] hover:bg-[#C5A028] transition-colors disabled:opacity-40 shrink-0">
                  <BellRing size={13} /> Email {g.pending}
                </button>
              </div>
            ))}
          </div>

          {/* Library compound requests — what shoppers want stocked next */}
          <div className="border border-zinc-800" data-testid="compound-requests-table">
            <div className="px-6 py-4 border-b border-zinc-800 flex items-center gap-3">
              <FlaskConical size={16} color="#D4AF37" />
              <div>
                <p className="font-serif text-xl font-light leading-tight">Library Compound Requests</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#52525B]">Shoppers tapped &quot;Request this compound&quot; on library-only peptides — your stocking wishlist</p>
              </div>
            </div>
            {(compoundReqs || []).length === 0 && <p className="p-8 text-center font-mono text-sm text-[#52525B]" data-testid="compound-requests-empty">No compound requests yet.</p>}
            {(compoundReqs || []).map((g) => (
              <div key={g.slug} className="px-6 py-4 border-b border-zinc-900 flex items-center justify-between gap-4 hover:bg-[#0C0C0C] transition-colors" data-testid={`compound-request-${g.slug}`}>
                <div className="min-w-0">
                  <p className="font-serif text-lg font-light">{g.name}</p>
                  <p className="font-mono text-[10px] text-[#52525B] mt-0.5">Last requested {g.latest ? new Date(g.latest).toLocaleDateString() : "—"} · <a href={`/library/${g.slug}`} target="_blank" rel="noreferrer" className="text-[#D4AF37] hover:underline">view article</a></p>
                </div>
                <span className="font-serif text-2xl text-[#D4AF37] shrink-0" data-testid={`compound-request-count-${g.slug}`}>{g.count} <span className="font-mono text-[10px] uppercase text-[#52525B]">request{g.count === 1 ? "" : "s"}</span></span>
              </div>
            ))}
          </div>
          </div>
  );
}
